import { mutator } from 'satcheljs';
import { cloneSxSStore } from '../actions/publicActions';
import getOrCreateSxSStoreData, { getNewStore } from '../store/Store';
import cloneDeep from 'lodash-es/cloneDeep';
import { ImagePreviewState } from 'owa-sxsdata';

mutator(cloneSxSStore, actionMessage => {
    const { sxsId, newSxSId } = actionMessage;
    // create a deep copy of the object
    const originalData = getOrCreateSxSStoreData(sxsId);
    const newSxSStoreData = cloneDeep(originalData);

    // cloneDeep doesn't work for observableArray so we need to manually copy it for imageGallery
    if (originalData?.viewState?.previewPane) {
        const imagePreviewState = originalData.viewState.previewPane as ImagePreviewState;
        if (imagePreviewState.imageGallery) {
            newSxSStoreData.viewState.previewPane = JSON.parse(
                JSON.stringify(originalData.viewState.previewPane)
            );
        }
    }

    getNewStore().sxsStoreMapping.set(newSxSId, newSxSStoreData);
});
